// extracted by mini-css-extract-plugin
export var divider = "_yo-0";